import Vue from 'vue'
import wx from 'weixin-js-sdk';
import api from '../api/index';
import { Toast } from 'vant';
//生成随机字符串
function randomString(len) {
	len = len || 32;
	var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
	var maxPos = $chars.length;
	var pwd = '';
	for (let i = 0; i < len; i++) {
		pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
	}
	return pwd;
}

let noncestr = randomString(17)
let timestamp = Date.parse(new Date()) / 1000
// let url = window.location.href.split('#')[0]
// let params = {
// 	jsapi_ticket: res.data.ticket,
// 	noncestr: noncestr,
// 	timestamp: timestamp,
// 	url: url
// }
// let signstr = ''
// for (let item in params) {
// 	signstr += item + '=' + params[item] + '&'
// }
// signstr = signstr.substr(0, signstr.length - 1)
// wx.config({
// 	beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
// 	debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
// 	appId: res.data.corpId, // 必填，企业微信的corpID
// 	// appId: 'wwf4285cde969adde2', // 必填，企业微信的corpID
// 	// appId: 'wx3f239ee0f2c6e820', // 必填，企业微信的corpID
// 	timestamp: timestamp, // 必填，生成签名的时间戳
// 	nonceStr: noncestr, // 必填，生成签名的随机串
// 	signature: sha1(signstr), // 必填，签名，见 附录-JS-SDK使用权限签名算法
// 	jsApiList: ["selectEnterpriseContact", "previewFile", "chooseImage", "getLocalImgData"] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
// });
// 字符串加密成 hex 字符串
function sha1(s) {
	var data = new Uint8Array(encodeUTF8(s))
	var i, j, t;
	var l = ((data.length + 8) >>> 6 << 4) + 16,
		s = new Uint8Array(l << 2);
	s.set(new Uint8Array(data.buffer)), s = new Uint32Array(s.buffer);
	for (t = new DataView(s.buffer), i = 0; i < l; i++) s[i] = t.getUint32(i << 2);
	s[data.length >> 2] |= 0x80 << (24 - (data.length & 3) * 8);
	s[l - 1] = data.length << 3;
	var w = [],
		f = [
			function () {
				return m[1] & m[2] | ~m[1] & m[3];
			},
			function () {
				return m[1] ^ m[2] ^ m[3];
			},
			function () {
				return m[1] & m[2] | m[1] & m[3] | m[2] & m[3];
			},
			function () {
				return m[1] ^ m[2] ^ m[3];
			}
		],
		rol = function (n, c) {
			return n << c | n >>> (32 - c);
		},
		k = [1518500249, 1859775393, -1894007588, -899497514],
		m = [1732584193, -271733879, null, null, -1009589776];
	m[2] = ~m[0], m[3] = ~m[1];
	for (i = 0; i < s.length; i += 16) {
		var o = m.slice(0);
		for (j = 0; j < 80; j++)
			w[j] = j < 16 ? s[i + j] : rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1),
				t = rol(m[0], 5) + f[j / 20 | 0]() + m[4] + w[j] + k[j / 20 | 0] | 0,
				m[1] = rol(m[1], 30), m.pop(), m.unshift(t);
		for (j = 0; j < 5; j++) m[j] = m[j] + o[j] | 0;
	};
	t = new DataView(new Uint32Array(m).buffer);
	for (var i = 0; i < 5; i++) m[i] = t.getUint32(i << 2);

	var hex = Array.prototype.map.call(new Uint8Array(new Uint32Array(m).buffer), function (e) {
		return (e < 16 ? "0" : "") + e.toString(16);
	}).join("");
	return hex;
}


function encodeUTF8(s) {
	var i, r = [],
		c, x;
	for (i = 0; i < s.length; i++)
		if ((c = s.charCodeAt(i)) < 0x80) r.push(c);
		else if (c < 0x800) r.push(0xC0 + (c >> 6 & 0x1F), 0x80 + (c & 0x3F));
		else {
			if ((x = c ^ 0xD800) >> 10 == 0) //对四字节UTF-16转换为Unicode
				c = (x << 10) + (s.charCodeAt(++i) ^ 0xDC00) + 0x10000,
					r.push(0xF0 + (c >> 18 & 0x7), 0x80 + (c >> 12 & 0x3F));
			else r.push(0xE0 + (c >> 12 & 0xF));
			r.push(0x80 + (c >> 6 & 0x3F), 0x80 + (c & 0x3F));
		};
	return r;
}
/* 微信sdk */

/* 初始化wxjsdk各种接口 */
let isCache = true
const init = (apiList = [], url) => {

	//需要使用的api列表
	return new Promise((resolve, reject) => {
		api.getSignature({ isCache }).then(res => {
			let params = {
				jsapi_ticket: res.Data.ticket,
				noncestr: noncestr,
				timestamp: timestamp,
				url: window.location.href
			}
			let signstr = ''
			for (let item in params) {
				signstr += item + '=' + params[item] + '&'
			}
			signstr = signstr.substr(0, signstr.length - 1)
			console.log('signstr----', signstr)
			if (res.Code === 0) {
				wx.config({
					beta: true,
					debug: false,
					appId: res.Data.appId,
					timestamp: timestamp,
					nonceStr: noncestr,
					signature: sha1(signstr),
					jsApiList: apiList
				})
				wx.ready(res => {
					// 微信SDK准备就绪后执行的回调。
					console.log('微信准备----',)
					resolve(wx)
				})
				wx.error(function (res) {
					console.log('微信调用失败', res)
					// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
				});
			} else {
				reject(res)
			}
		})
	})
}

// 企微初始化重试次数

/**
 * selectedDepartmentIds 已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
 * selectedUserIds  已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
*/
// export const selectEnterpriseContact = (selectedUserIds = []) => {
// 	return new Promise((resolve, reject) => {
// 		init(['selectEnterpriseContact']).then(wx => {
// 			// setTimeout(() => {
// 			wx.invoke('selectEnterpriseContact', {
// 				"fromDepartmentId": 0,// 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
// 				"mode": "multi",// 必填，选择模式，single表示单选，multi表示多选
// 				"type": ["user"],  // department:部门, user:人员
// 				// selectedDepartmentIds,
// 				selectedUserIds
// 			}, function (e) {
// 				console.log('数据=----', e)
// 				if (e.err_msg === "selectEnterpriseContact:ok") {
// 					if (typeof e.result === 'string') {
// 						e.result = JSON.parse(e.result)
// 					}
// 					resolve(e.result)
// 				} else {
// 					reject(e.err_msg)
// 				}
// 				// }, [100])
// 			})
// 		})
// 	})
// }

// 企微初始化重试次数
let wxInitRetryNum = 0

function wxInit(apiList = ['selectEnterpriseContact'], showTip = false) {
	api.getSignature({ isCache }).then(res => {
		// 处理调用企微的参数
		let params = {
			jsapi_ticket: res.Data.ticket,
			noncestr: noncestr,
			timestamp: timestamp,
			url: window.location.href
		}
		let signstr = ''
		for (let item in params) {
			signstr += item + '=' + params[item] + '&'
		}
		signstr = signstr.substr(0, signstr.length - 1)
		console.log('wx params:', signstr)

		// 调用企微sdk
		wx.config({
			beta: true,
			debug: false,
			appId: res.Data.appId,
			timestamp: timestamp,
			nonceStr: noncestr,
			signature: sha1(signstr),
			jsApiList: apiList
		})
		wx.ready(function () {
			// 微信SDK准备就绪后执行的回调。
			console.log('===微信初始化完成')
			// 这里只是表示SDK准备就绪，并不代表config验证成功
			window.WX_READY = true
		})
		wx.error(function (res) {

			console.log('===微信初始化失败', res)
			window.WX_READY = false
			// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。

			// 如果企微调用失败，则重试3次，3次之后还失败则不再试了，并将重试次数清零
			// 后面如果有操作触发了企微功能调用，则会重新调用初始化
			if (wxInitRetryNum < 3) {
				isCache = false
				// 重新获取Tircket
				wxInit(apiList, showTip)
				wxInitRetryNum++
				console.log('微信初始化重试', wxInitRetryNum)
			} else {
				wxInitRetryNum = 0
				console.log('微信初始化重试后还是失败')
			}
		});
	}).catch((err) => {
	}).finally(() => {
		if (showTip) {
			// 显示加载loading
		}
	})
}

function selectEnterpriseContact(selectedUserIds = []) {
	return new Promise((resolve, reject) => {
		if (window.WX_READY) {
			wx.invoke('selectEnterpriseContact', {
				"fromDepartmentId": 0,// 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
				"mode": "multi",// 必填，选择模式，single表示单选，multi表示多选
				"type": ["user"],  // department:部门, user:人员
				// selectedDepartmentIds,
				selectedUserIds
			}, function (e) {
				console.log('人员数据:', e)
				if (e.err_msg === "selectEnterpriseContact:ok") {
					if (typeof e.result === 'string') {
						e.result = JSON.parse(e.result)
					}
					resolve(e.result)
				} else {
					reject(e.err_msg)
				}
			})
		} else {
			Toast(i18n.t('wx.selectUserErr'))
			wxInit()
		}
	})
}


Vue.prototype.$wx = {
	sdk: wx,
	init: wxInit,
	selectEnterpriseContact
}

export default { sdk: wx, init: wxInit, selectEnterpriseContact };
